/* eslint-disable */
import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
// import { fetchGame } from '../../common/js/ajax';
import { tools } from 'newcar-ui/output/es/utils';
import { MOTORSHOW_MODULE } from '../../common/js/contants';
import './index.scss'
import "newcar-ui/output/index.css";
// import { Prompt } from 'newcar-ui/output/cjs/components/Prompt'
window.initnumber = 0;
window.gapHeight = 0;
let timeout1, timeout2, interval, timeout;
window.isAndroid = false;
let u = navigator.userAgent;
if (u.indexOf('Android') > -1 || u.indexOf('Adr') > -1) {
    window.isAndroid = true;
}
const TestGame = (props) => {
    const { navIndex, Width, moduleList, popTime, changeTab, maskCallback, Height, is58App } = props;
    // let id1, // 新车预告
    // id2, // 同镇站长新车推荐
    // id3, // 车展快讯
    // id4, // 新车实拍
    // id5, // 车展趣闻
    // id6, // 车展热聊
    // id7, // 品牌专访
    // id8, // 好车推荐
    // id9; // 趣味角;
    // moduleList.map((item)=>{
    //     item.id =
    // })
    // const [gapHeight, setGapHeight] = useState(0)
    const [id2,setId2] = useState(moduleList[1])
    const [id7,setId7] = useState(moduleList[6])
    // 气泡
    const [id3Pop, setId3Pop] = useState(moduleList[2].bubble[0] || { title: '', pic: "" })
    const [id4Pop, setId4Pop] = useState(moduleList[3].bubble[0] || { title: '', pic: "" })
    const [id8Pop, setId8Pop] = useState(moduleList[7].bubble[0] || { title: '', pic: "" })
    const [id9Pop, setId9Pop] = useState(moduleList[8].bubble[0] || { title: '', pic: "" })
    const scroll = useRef(null);
    const svg = useRef(null);
    const shipai = useRef(null);
    const kuaixun = useRef(null);
    const tuijian = useRef(null);
    const quwei = useRef(null);
    const [fixed, setFixed] = useState(false);
    const [width, setWidth] = useState(Width || 1);
    const [canMove, setCanMove] = useState(false);

    const [wrapHieght, setWrapHieght] = useState(1000);
    const [transparent, setTransparent] = useState(0);
    const [heightPx, setHeightPx] = useState('')
    const scrollFn = useCallback((e) => {
        const target = e.target;
        const scrollHeight = target.scrollHeight;
        const scrollTop = target.scrollTop;
        // console.log(scrollTop ,window.heightPx)
        if (scrollTop > window.heightPx) {
            setFixed(true);
        } else {
            setTransparent((scrollTop / window.heightPx) * 0.4)
            setFixed(false)
        }
    }, [fixed])
    //  品牌专访1 好车推荐2 车展趣闻3 车展热聊4 趣味角5 车展快讯6 新车预告7 新车实拍8 直播9
    const pop = useCallback((type,item) => {
        tools.sendClickStatistics_wmda(338, {
            name: MOTORSHOW_MODULE[type],
            actionType: '24biae-area-click'
        });
        sessionStorage.setItem('currentPop', type);
        props.getModuleInfo(type,item)
        // console.log(11111)
        // changeWindow(width * 1.5);
    }, [width])

    const changeWindow = useCallback((width) => {
        setWidth(width);
        setCanMove(true)
        scroll.current.scrollTo({
            top: window.heightPx,
            left: 0,
            behavior: "smooth",
        });
        window.move = true;
        window.mapHeight = width / 2250 * 4200;
        // 最大高度
        window.maxHeight = window.mapHeight - window.wrapHieght;
        // 最大宽度
        window.maxWidth = width - window.innerWidth;
    }, [])
    const touchStart = useCallback((e) => {
        window.startX = e.changedTouches[0].clientX;
        window.startY = e.changedTouches[0].clientY;
        // console.log(startX, startY)
    }, [])
    const touchMove = useCallback((e) => {
        const moveX = e.changedTouches[0].clientX - window.startX;
        const moveY = e.changedTouches[0].clientY - window.startY;
        let svgTop_ = window.svgTop + moveY
        let svgleft_ = window.svgleft + moveX;
        if (svgTop_ < window.maxHeight) {
            svgTop_ = window.maxHeight
        } else if (svgTop_ > 0) {
            svgTop_ = 0;
        }
        if (svgleft_ < window.maxWidth) {
            svgleft_ = window.maxWidth
        } else if (svgleft_ > 0) {
            svgleft_ = 0;
        }
        if (window.canMove) {
            svg.current.setAttribute('style', `top:${svgTop_}px;left:${svgleft_}px`)
        }
    }, [])
    const touchEnd = useCallback((e) => {
        const moveX = e.changedTouches[0].clientX - window.startX;
        const moveY = e.changedTouches[0].clientY - window.startY;
        window.svgTop = window.svgTop + moveY;
        window.svgleft = window.svgleft + moveX;
        // console.log(window.svgTop, window.svgleft)
        // 监听所有元素的位置切换底部tab
        if (window.canMove) {
            filterBigArea()
        }
    }, [])
    const filterBigArea = useCallback((a, b, c, d) => {
        // const bake = document.getElementById('bake');
        // const topHeight = 1.61 * parseInt(window.getComputedStyle(bake).height)
        // const botHeight = 1.03 * parseInt(window.getComputedStyle(bake).height)
        // const shipaiRect = shipai.current.getBoundingClientRect();
        // const quweiRect = quwei.current.getBoundingClientRect();
        // const tuijianRect = tuijian.current.getBoundingClientRect();
        // const kuaixunRect = kuaixun.current.getBoundingClientRect();
        // svg的高度
        // const wrapHieght = window.wrapHieght
        // 宽度
        // Width
        // const shipaiArea = calcArea(shipaiRect, topHeight, botHeight, 'shipaiRect');
        // const quweiArea = calcArea(quweiRect, topHeight, botHeight, 'quweiRect')
        // const tuijianArea = calcArea(tuijianRect, topHeight, botHeight, 'tuijianRect')
        // const kuaixunArea = calcArea(kuaixunRect, topHeight, botHeight, 'kuaixunRect')
        // const maxList = [parseInt(shipaiArea), parseInt(kuaixunArea), parseInt(quweiArea), parseInt(tuijianArea)];
        // const max = Math.max(...maxList);
        // console.log(max, maxList)
        // const id = maxList.indexOf(max);
        // const random = '-' + Date.now();
        // 0 1 3 4
        // changeTab(null, id > 1 ? id + 1 + random : id + random)

        const realWidth = Width * 1.5 / 2;
        const realHieght = Width / 2250 * 4200 * 1.5 / 2;
        const shipaiArea = calcArea_(0, realWidth, realHieght, 'shipaiRect');
        const quweiArea = calcArea_(3, realWidth, realHieght, 'quweiRect')
        const tuijianArea = calcArea_(4, realWidth, realHieght, 'tuijianRect')
        const kuaixunArea = calcArea_(1, realWidth, realHieght, 'kuaixunRect')
        const maxList = [parseInt(shipaiArea), parseInt(kuaixunArea), parseInt(quweiArea), parseInt(tuijianArea)];

        const max = Math.max(...maxList);
        // console.log(max, maxList)
        const id = maxList.indexOf(max);
        const random = '-' + Date.now();
        // 0 1 3 4
        changeTab(null, id > 1 ? id + 1 + random : id + random)
    }, [Width])
    const calcArea_ = useCallback((index, realWidth, realHieght, name) => {
        let width = 0;
        let height = 0;
        // 新车实拍
        if (index == 0) {
            width = realWidth + window.svgleft;
            height = realHieght + window.svgTop;
        } else if (index == 1) {
            // 车展快讯
            width = realWidth / 3 - window.svgleft;
            height = realHieght + window.svgTop;
        } else if (index == 3) {
            // 趣味角
            width = realWidth + window.svgleft;
            height = realHieght - (window.mapHeight - window.wrapHieght) - window.svgTop;
        } else if (index == 4) {
            //新车推荐
            width = realWidth / 3 - window.svgleft;
            height = realHieght - (window.mapHeight - window.wrapHieght) - window.svgTop;
        }
        if (width <= 0) {
            width = 0;
        }
        if (height <= 0) {
            height = 0;
        }
        return width * height;
    }, [])


    useEffect(() => {
        // 监听窗体大小
        window.addEventListener('resize', function (e) {
            if (Width != e.target.screen.width) {
                window.location.reload();
            } else if (e.target.innerHeight != Height) {
                // 走重新初始化){
                window.gapHeight = e.target.innerHeight - Height;
                // alert(`${Height},${e.target.innerHeight},${gapHeight}`);
                // setGapHeight(gapHeight);
                // window.gapHeight = gapHeight;
                window.maxHeight = window.wrapHieght + gapHeight - window.mapHeight;
                // alert(e.target.innerHeight)
                document.getElementById('root').setAttribute('style', `height:${e.target.innerHeight}px!important;`)
            } else {
                window.gapHeight = e.target.innerHeight - Height;
                // alert(`${Height},${e.target.innerHeight},${gapHeight}`);
                // setGapHeight(gapHeight);
                // window.gapHeight = gapHeight;
                window.maxHeight = window.wrapHieght + gapHeight - window.mapHeight;
                // alert(e.target.innerHeight)
                if (window.isAndroid) {
                    setCanMove(false);
                }
                document.getElementById('root').setAttribute('style', `height:${e.target.innerHeight}px!important;`)
                scroll.current.setAttribute("style", "overflow:scroll;")
                if (scroll.current.scrollTo) {
                    scroll.current.scrollTo({
                        top: window.heightPx,
                        left: 0
                    });
                } else {
                    scroll.current.scrollTop = window.heightPx;
                }
                // alert(e.target.innerHeight)
            }
        })
        window.addEventListener('visibilitychange', function (e) {
            if (is58App) {
                return
            }
            if (Width != e.currentTarget.screen.width) {
                window.location.reload();
            } else if (e.currentTarget.innerHeight != Height) {

                // 走重新初始化
                window.gapHeight = e.currentTarget.innerHeight - Height;

                window.maxHeight = window.wrapHieght + gapHeight - window.mapHeight;
                document.getElementById('root').setAttribute('style', `height:${e.currentTarget.innerHeight}px!important;`)
            }
            clearInterval(interval) && clearTimeout(timeout);
            timeout = setTimeout(() => {
                window.initnumber++;
                moduleList[2].bubble.length > 0 && setId3Pop(moduleList[2].bubble[(initnumber % moduleList[2].bubble.length)]);
                moduleList[3].bubble.length > 0 && setId4Pop(moduleList[3].bubble[(initnumber % moduleList[3].bubble.length)]);
                moduleList[7].bubble.length > 0 && setId8Pop(moduleList[7].bubble[(initnumber % moduleList[7].bubble.length)]);
                moduleList[8].bubble.length > 0 && setId9Pop(moduleList[8].bubble[(initnumber % moduleList[8].bubble.length)]);
                interval = setInterval(() => {
                    window.initnumber++;
                    moduleList[2].bubble.length > 0 && setId3Pop(moduleList[2].bubble[(initnumber % moduleList[2].bubble.length)]);
                    moduleList[3].bubble.length > 0 && setId4Pop(moduleList[3].bubble[(initnumber % moduleList[3].bubble.length)]);
                    moduleList[7].bubble.length > 0 && setId8Pop(moduleList[7].bubble[(initnumber % moduleList[7].bubble.length)]);
                    moduleList[8].bubble.length > 0 && setId9Pop(moduleList[8].bubble[(initnumber % moduleList[8].bubble.length)]);
                }, popTime * 1000);
            }, popTime * 800);
        })
        if (Width > 700) {
            return
        }
        const bake = document.getElementById('bake');
        // 距离顶部滚动的最大距离
        window.heightPx = parseInt(window.getComputedStyle(bake).height) * 1.28;
        // 距离顶部高度+底部tab高度
        window.heightPx1_5 = parseInt(window.getComputedStyle(bake).height) * 2.33;
        // 固定环形位置
        window.heightPx1 = parseInt(window.getComputedStyle(bake).height) * 0.9;
        setHeightPx(window.heightPx1);
        // 地图高度
        window.mapHeight = width / 2250 * 4200 * 1.5;
        // svg外层高度
        const wrapHieght = window.innerHeight - window.heightPx1_5;
        setWrapHieght(wrapHieght)
        window.wrapHieght = wrapHieght;
        // 最大高度
        window.maxHeight = window.wrapHieght - window.mapHeight;
        // 最大宽度
        window.maxWidth = (innerWidth - (width * 1.5));
        // 滚动事件
        scroll.current.removeEventListener('scroll', scrollFn);
        scroll.current.addEventListener('scroll', scrollFn);
        // svg移动的位置
        window.svgTop = 0
        window.svgleft = 0
        window.move = false;
        timeout = setTimeout(() => {
            window.initnumber++;
            moduleList[2].bubble.length > 0 && setId3Pop(moduleList[2].bubble[(initnumber % moduleList[2].bubble.length)]);
            moduleList[3].bubble.length > 0 && setId4Pop(moduleList[3].bubble[(initnumber % moduleList[3].bubble.length)]);
            moduleList[7].bubble.length > 0 && setId8Pop(moduleList[7].bubble[(initnumber % moduleList[7].bubble.length)]);
            moduleList[8].bubble.length > 0 && setId9Pop(moduleList[8].bubble[(initnumber % moduleList[8].bubble.length)]);
            interval = setInterval(() => {
                window.initnumber++;
                moduleList[2].bubble.length > 0 && setId3Pop(moduleList[2].bubble[(initnumber % moduleList[2].bubble.length)]);
                moduleList[3].bubble.length > 0 && setId4Pop(moduleList[3].bubble[(initnumber % moduleList[3].bubble.length)]);
                moduleList[7].bubble.length > 0 && setId8Pop(moduleList[7].bubble[(initnumber % moduleList[7].bubble.length)]);
                moduleList[8].bubble.length > 0 && setId9Pop(moduleList[8].bubble[(initnumber % moduleList[8].bubble.length)]);
            }, popTime * 1000);
        }, popTime * 800);
        // 安卓
        if (window.isAndroid) {
            let currentPop = sessionStorage.getItem('currentPop')
            if (currentPop == 6 || currentPop == 9 || !currentPop) {

            } else {
                setTimeout(() => {
                    pop(parseInt(sessionStorage.getItem('currentPop')))
                }, 1000);
            }

        }
        return clearInterval(interval) && clearTimeout(timeout)
    }, [])
    useEffect(() => {
        if (Width > 700) {
            svg.current.setAttribute('style', `position:relative;`)
            return
        }
        // console.log('entertop', navIndex);
        let wrapIndex = '';
        scroll.current.setAttribute("style", "overflow:scroll;")
        svg.current.setAttribute('style', `top:0px;left:0px`)
        if (scroll.current.scrollTo) {
            scroll.current.scrollTo({
                top: 0,
                left: 0
            });
        } else {
            scroll.current.scrollTop = 0;
        }
        // scroll.current.scrollTop = 1000;
        // scroll.current.scrollTo({
        //     top: 0,
        //     left: 0,
        // });
        if (navIndex == '') {
            return
        } else {
            wrapIndex = navIndex.split('-')[0]
        }
        let svgTop_, svgleft_;
        if (timeout1) {
            clearTimeout(timeout1);
            timeout1 = null;
        }
        if (timeout2) {
            clearTimeout(timeout2);
            timeout2 = null;
        }
        // console.log('entermid');
        if (wrapIndex == 2) {
            // console.log('wrapIndex==2')
            if (scroll.current.scrollTo) {
                scroll.current.scrollTo({
                    top: 0,
                    left: 0
                });
            } else {
                scroll.current.scrollTop = 0;
            }

            setFixed(false)
            maskCallback();
            window.canMove = false;
            setWidth(Width)
            setCanMove(false);
        } else {
            // console.log('wrapIndex', wrapIndex)
            if (wrapIndex == 0) {
                svgTop_ = 0;
                svgleft_ = 0;
            } else if (wrapIndex == 1) {
                svgTop_ = 0;
                svgleft_ = window.maxWidth;
            } else if (wrapIndex == 3) {
                svgTop_ = window.maxHeight;
                svgleft_ = 0;
            } else if (wrapIndex == 4) {
                svgTop_ = window.maxHeight;
                svgleft_ = window.maxWidth;
            }
            // if (!window.canMove) {
            // console.log('move')
            setWidth(Width * 1.5)
            setCanMove(true);
            window.canMove = true;
            setWrapHieght(window.wrapHieght);
            timeout1 = setTimeout(() => {
                // console.log('timer1');
                if (scroll.current.scrollTo) {
                    scroll.current.scrollTo({
                        top: window.heightPx,
                        left: 0,
                        behavior: "smooth",
                    });
                } else {
                    scroll.current.scrollTop = window.heightPx;
                }
                // scroll.current.scrollTo({
                //     top: window.heightPx,
                //     left: 0,
                //     behavior: "smooth",
                // });
                timeout2 = setTimeout(() => {
                    scroll.current.setAttribute("style", "overflow:hidden;");
                    maskCallback();

                }, 1000);
            }, 1000);
            // }
            window.svgTop = svgTop_;
            window.svgleft = svgleft_;
            svg.current.setAttribute('style', `top:${svgTop_}px;left:${svgleft_}px`)
        }
    }, [navIndex])
    return <div className="kv-map" ref={scroll}>

        <div className="kv" style={fixed ? { backgroundImage: `url(//icon.xgo-img.com.cn/topic/${canMove ? '24041210':'24040817'}/2.png)`, zIndex: 3, backgroundSize: '3.75rem 1.7rem', height: '3.75rem' } : {}}>
            {!fixed &&!canMove&& <div className="kv-transparent" style={{ background: `rgba(0,0,0,${transparent})` }}></div>}
        </div>
        <div className="map">
            <div className="dc" style={fixed ? { position: "fixed", top: heightPx + "px" } : {}}></div>
            <div className="map-wrap" style={canMove ? { height: wrapHieght + window.gapHeight + 'px' } : { height: parseInt(width / 2250 * 4200) + 'px', overflow: 'scroll' }}>
                <svg id="svg" xmlns="//www.w3.org/2000/svg"
                    xmlnsXlink="//www.w3.org/1999/xlink"
                    className="map-svg"
                    width={width}
                    height={parseInt(width / 2250 * 4200)}
                    onTouchStart={touchStart}
                    onTouchMove={touchMove}
                    onTouchEnd={touchEnd}
                    style={{ top }}
                    ref={svg}
                    viewBox="0 0 2250 4200">
                    <defs>
                        <image id="image1" width="501" height="288" xlinkHref="//icon.xgo-img.com.cn/topic/24041916/tingchewei.png" />
                        <image id="image-2" width="260" height="294" xlinkHref="//icon.xgo-img.com.cn/topic/24041916/zhanpai1.png" />
                        <image id="image3" width="230" height="216" xlinkHref="//icon.xgo-img.com.cn/topic/24041916/liba.png" />
                        <filter id="filter" x="1448" y="3592" width="538" height="127" filterUnits="userSpaceOnUse">
                            <feOffset result="offset" dy="12" in="SourceAlpha" />
                            <feGaussianBlur result="blur" stdDeviation="4.899" />
                            <feFlood result="flood" floodColor="#292d34" floodOpacity="0.5" />
                            <feComposite result="composite" operator="in" in2="blur" />
                            <feBlend result="blend" in="SourceGraphic" />
                        </filter>
                        <filter id="filter-2" x="1303" y="3550" width="227" height="207" filterUnits="userSpaceOnUse">
                            <feOffset result="offset" dy="12" in="SourceAlpha" />
                            <feGaussianBlur result="blur" stdDeviation="4.899" />
                            <feFlood result="flood" floodColor="#292d34" floodOpacity="0.5" />
                            <feComposite result="composite" operator="in" in2="blur" />
                            <feBlend result="blend" in="SourceGraphic" />
                        </filter>
                        <filter id="filter-3" x="251" y="221" width="325" height="306" filterUnits="userSpaceOnUse">
                            <feOffset result="offset" dy="12" in="SourceAlpha" />
                            <feGaussianBlur result="blur" stdDeviation="4.899" />
                            <feFlood result="flood" floodColor="#292d34" floodOpacity="0.5" />
                            <feComposite result="composite" operator="in" in2="blur" />
                            <feBlend result="blend" in="SourceGraphic" />
                        </filter>
                        <filter id="filter-4" x="268" y="3038" width="538" height="146" filterUnits="userSpaceOnUse">
                            <feOffset result="offset" dy="12" in="SourceAlpha" />
                            <feGaussianBlur result="blur" stdDeviation="4.899" />
                            <feFlood result="flood" floodColor="#292d34" floodOpacity="0.5" />
                            <feComposite result="composite" operator="in" in2="blur" />
                            <feBlend result="blend" in="SourceGraphic" />
                        </filter>
                        <filter id="filter-5" x="1445" y="495" width="538" height="146" filterUnits="userSpaceOnUse">
                            <feOffset result="offset" dy="12" in="SourceAlpha" />
                            <feGaussianBlur result="blur" stdDeviation="4.899" />
                            <feFlood result="flood" floodColor="#292d34" floodOpacity="0.5" />
                            <feComposite result="composite" operator="in" in2="blur" />
                            <feBlend result="blend" in="SourceGraphic" />
                        </filter>
                        <image id="image" width="142" height="397" xlinkHref="//icon.xgo-img.com.cn/topic/24040717/dd2.png" />
                    </defs>
                    <image id="阴影" x="300" y="3538" width="479" height="253" xlinkHref="//icon.xgo-img.com.cn/topic/24040716/yy.png" />
                    {/* <image id="弱化" x="-44" y="117" width="2301" height="2603" xlinkHref="//icon.xgo-img.com.cn/topic/24040716/rh.png" /> */}
                    <g id="地图">
                        <g id="停车位">
                            <image id="_2" data-name="2" x="1799" y="1065" width="501" height="288" xlinkHref="//icon.xgo-img.com.cn/topic/24041916/tingchewei.png" />
                            <use id="_2_拷贝" data-name="2 拷贝" x="1947" y="3465" xlinkHref="#image1" />
                            <use id="_2_拷贝_3" data-name="2 拷贝 3" x="-124" y="3709" xlinkHref="#image1" />
                            <image id="图层_1" data-name="图层 1" x="200" y="3893" width="501" height="288" xlinkHref="//icon.xgo-img.com.cn/topic/24041916/tingchewei.png" />
                            {/* <use id="_2_拷贝_2" data-name="2 拷贝 2" x="-73" y="950" xlinkHref="#image1" /> */}
                        </g>

                        {/* <image id="树" x="182" y="1107" width="1491" height="2570" xlinkHref="//icon.xgo-img.com.cn/topic/24041916/tingchewei.png" /> */}


                    </g>
                    <g id="模块">
                        <use id="图层_4" data-name="图层 4" x="1443" y="3461" xlinkHref="#image3" />
                        <use id="图层_5" data-name="图层 5" x="182" y="1107" xlinkHref="#image3" />
                        <image id="公交站" x="1177" y="945" width="260" height="306" xlinkHref="//icon.xgo-img.com.cn/topic/24041916/zhanpai.png" />
                        <image id="图层_3" data-name="图层 3" x="531" y="2660" width="260" height="307" xlinkHref="//icon.xgo-img.com.cn/topic/24041916/zhanpai.png" />
                        <use id="图层_2" data-name="图层 2" x="1186" y="3563" xlinkHref="#image-2" />
                        <use id="图层_2_拷贝" data-name="图层 2 拷贝" x="809" y="3350" xlinkHref="#image-2" />
                        <image id="车-01" x="734" y="920" width="441" height="323" xlinkHref="//icon.xgo-img.com.cn/topic/24041916/che.png" />
                        <image id="车-02" x="779" y="2740" width="441" height="323" xlinkHref="//icon.xgo-img.com.cn/topic/24041916/che.png" />
                        <image id="车-01_拷贝" data-name="车-01 拷贝" x="1489" y="1819" width="441" height="323" xlinkHref="//icon.xgo-img.com.cn/topic/24041916/che1.png" />
                        {id7.status == 0 ?<image id="品牌专访-2" x="1528" y="2937" width="674" height="598" xlinkHref="//icon.xgo-img.com.cn/topic/24041019/ppzfclose.png" />: <image onClick={() => pop(7)} id="品牌专访-1" x="1528" y="2937" width="674" height="598" xlinkHref="//icon.xgo-img.com.cn/topic/24040716/ppzf.png" />}
                        {id7.status == 0 && <image id="锁ppzz" x="1770" y="3170" width="165" height="156" xlinkHref="//icon.xgo-img.com.cn/topic/24040716/dsadqdq.png" />}
                        <image onClick={() => pop(8)} id="好车推荐-1" ref={tuijian} x="1446" y="3577" width="542" height="619" xlinkHref="//icon.xgo-img.com.cn/topic/24040716/hctj.png" />
                        <image onClick={() => pop(5)} id="车展趣闻-1" x="1745" y="2130" width="472" height="554" xlinkHref="//icon.xgo-img.com.cn/topic/24041916/chejieshengdian.png" />
                        <image onClick={() => pop(6, moduleList[5])} id="车展热聊-1" x="58" y="2280" width="453" height="701" xlinkHref="//icon.xgo-img.com.cn/topic/24040716/czrl.png" />
                        <image onClick={() => pop(9, moduleList[8])} id="趣味角-1" ref={quwei} x="310" y="3022" width="458" height="761" xlinkHref="//icon.xgo-img.com.cn/topic/24040716/qwj.png" />
                        <image onClick={() => pop(3)} id="车展快讯-1" ref={kuaixun} x="1460" y="474" width="521" height="693" xlinkHref="//icon.xgo-img.com.cn/topic/24041916/tuwenkuanxun.png" />
                        <image onClick={() => pop(1)} id="新车预告-1" x="56" y="1280" width="472" height="597" xlinkHref="//icon.xgo-img.com.cn/topic/24040716/xcyg.png" />
                        {id2.status == 0 ? <image id="同镇站长未开启" x="1713" y="1248" width="506" height="607" xlinkHref="//icon.xgo-img.com.cn/topic/24040716/lock.png" /> : <image onClick={() => pop(2)} id="同镇站长-1" x="1713" y="1248" width="506" height="607" xlinkHref="//icon.xgo-img.com.cn/topic/24041019/tzzzopen.png" />}
                        {id2.status == 0 && <image id="锁" x="1883" y="1473" width="165" height="156" xlinkHref="//icon.xgo-img.com.cn/topic/24040716/dsadqdq.png" />}
                        <image onClick={() => pop(4)} id="投影" ref={shipai} x="62" y="325" width="973" height="875" xlinkHref="//icon.xgo-img.com.cn/topic/24040716/xcsp.png" style={{ position: 'relative' }}>
                        </image>
                        <image onClick={() => pop(10)} id="圆环" x="551" y="1197" width="1136" height="1358" xlinkHref="//icon.xgo-img.com.cn/topic/24041916/zhibo.png" />
                        <use id="_58汽车_拷贝" data-name="58汽车 拷贝" x="1201" y="2317" xlinkHref="#image" />
                        <use id="_58汽车_拷贝_2" data-name="58汽车 拷贝 2" x="2006" y="665" xlinkHref="#image" />
                        <use id="_58汽车_拷贝_3" data-name="58汽车 拷贝 3" x="73" y="3293" xlinkHref="#image" />
                    </g>
                    {/* <image id="_1" data-name="1" x="974" y="2549" width="943" height="631" xlinkHref="//icon.xgo-img.com.cn/topic/24040717/dd.png" />
                    <image id="_2" data-name="2" x="1368" y="2454" width="383" height="310" xlinkHref="//icon.xgo-img.com.cn/topic/24040717/dd1.png" /> */}
                    <g id="气泡标签">
                        {id8Pop.pic && <g id="好车推荐" className="like-heart" onClick={() => pop(8)}>
                            <g id="组_26" data-name="组 26">
                                <g style={{ fill: "#fff", filter: "url(#filter)" }}>
                                    <path id="矩形_842_拷贝" data-name="矩形 842 拷贝" className="cls-1" d="M1510.55,3603.53h411.5a39.33,39.33,0,0,1,0,78.66h-411.5A39.33,39.33,0,1,1,1510.55,3603.53Z" style={{ stroke: "inherit", filter: "none", fill: "inherit" }} />
                                </g>
                                <use xlinkHref="#矩形_842_拷贝" style={{ stroke: "#d1dde8", filter: "none", fill: "none" }} />
                                <text id="这里是一段文字内容_拷贝" data-name="这里是一段文字内容 拷贝" className="cls-2" transform="translate(1716.62 3658.066) scale(0.75 0.75)"><tspan x="0">{id8Pop.title||''}</tspan></text>
                            </g>
                            <g id="组_34" data-name="组 34" >
                                <g style={{ fill: "#fff", filter: "url(#filter-2)" }}>
                                    <rect id="矩形_843" data-name="矩形 843" className="cls-3" x="1326" y="3561" width="180" height="160" rx="24" ry="24" style={{ stroke: "inherit", filter: "none", fill: "inherit" }} />
                                </g>
                                <use xlinkHref="#矩形_843" style={{ stroke: "#d1dde8", filter: "none", fill: "none" }} />
                                <image   x="1326" y="3561" width="180" height="160" xlinkHref={id8Pop.pic||''} />
                            </g>
                        </g>}
                        {id4Pop.pic && <g style={{ fill: "#fff", filter: "url(#filter-3)" }} className="like-heart" onClick={() => pop(4)}>
                        <image id="新车实拍-2" x="251" y="221" width="325" height="306"  xlinkHref={id4Pop.pic||''} />  
                        </g>}
                        {id9Pop.title && <g id="趣味角" className="like-heart" onClick={() => pop(9)}>
                            <g style={{ fill: "#fff", filter: "url(#filter-4)" }}>
                                <path id="矩形_842" data-name="矩形 842" className="cls-5" d="M742.047,3128.19H556.076L536.3,3147.97l-19.777-19.78H330.547a39.33,39.33,0,0,1,0-78.66h411.5A39.33,39.33,0,0,1,742.047,3128.19Z" style={{ stroke: "inherit", filter: "none", fill: "inherit" }} />
                            </g>
                            <use xlinkHref="#矩形_842" style={{ stroke: "#d1dde8", filter: "none", fill: "none" }} />
                            <text id="这里是一段文字内容" className="cls-2" transform="translate(536.618 3104.065) scale(0.75 0.75)"><tspan x="0">{(id9Pop.title.length>12?id9Pop.title.substr(0,10)+'...':id9Pop.title)||''}</tspan></text>
                        </g>}
                        {id3Pop.title && <g id="车展快讯" className="like-heart" onClick={() => pop(3)}>
                            <g style={{ fill: "#fff", filter: " url(#filter-5)" }}>
                                <path id="矩形_842-2" data-name="矩形 842" className="cls-6" d="M1919.05,585.187H1733.07l0.01,0.006-19.78,19.778-19.78-19.778,0.01-.006H1507.55a39.328,39.328,0,1,1,0-78.656h411.5A39.328,39.328,0,0,1,1919.05,585.187Z" style={{ stroke: "inherit", filter: "none", fill: "inherit" }} />
                            </g>
                            <use xlinkHref="#矩形_842-2" style={{ stroke: "#d1dde8", filter: "none", fill: "none" }} />
                            <text id="这里是一段文字内容-2" data-name="这里是一段文字内容" className="cls-2" transform="translate(1713.618 561.065) scale(0.75 0.75)"><tspan x="0" style={{ overflow: 'hidden' }}>{(id3Pop.title.length > 12 ? id3Pop.title.substr(0, 10) + '...' : id3Pop.title) || ''}</tspan></text>
                        </g>}
                    </g>

                    {/* <image id="弱化" x="-44" y="117" width="2301" height="2603" xlinkHref="//icon.xgo-img.com.cn/topic/24041916/tingchewei.png" /> */}
                    <g id="模块">
                        {/* <image id="车界盛典-1" x="1745" y="2130" width="472" height="554" xlinkHref="//icon.xgo-img.com.cn/topic/24041916/tingchewei.png" /> */}
                        {/* <image id="图文快讯-1" x="1460" y="474" width="521" height="693" xlinkHref="//icon.xgo-img.com.cn/topic/24041916/tingchewei.png" /> */}
                        {/* <image id="圆环" x="551" y="1197" width="1136" height="1358" xlinkHref="//icon.xgo-img.com.cn/topic/24041916/tingchewei.png" /> */}
                        {/* <use id="_58汽车_拷贝" data-name="58汽车 拷贝" x="1201" y="2317" xlinkHref="#image-3" />
                        <use id="_58汽车_拷贝_2" data-name="58汽车 拷贝 2" x="2006" y="665" xlinkHref="#image-3" />
                        <use id="_58汽车_拷贝_3" data-name="58汽车 拷贝 3" x="73" y="3293" xlinkHref="#image-3" /> */}
                    </g>
                </svg>
            </div>
            {Width < 700 && <div id='bake1' style={{ height: '0.75rem', visibility: 'hidden' }}></div>}
        </div>
    </div>
}
export default TestGame;